import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'sd-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {
  header: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ) {}

  ngOnInit() {
    this.header = this.data.header;
    this.message = this.data.message;
  }

  cancelAction() {
    this.dialogRef.close(false);
  }

  confirmAction() {
    this.dialogRef.close(true);
  }
}
